module.exports = __webpack_public_path__ + "img/2_en.df2db57f.jpg";